import { RecordIdentifier } from "@/data/global";
import { CourseProduct, Product } from "@/data/products";

/**
 * To actually use them in Vue templates, there is some magic required: https://github.com/davestewart/vue-enums
 */
export enum VoucherType {
    Discount = 0,
    Product = 1,
    Order = 2,
}

export interface VoucherRedemptionCheckResult {
    code: string,
    type: VoucherType,
    type_label: string,
    region_id: RecordIdentifier,
    redeemable_as_guest: boolean,
    expired: boolean,
    discount_percentage?: number,
    product?: Product|CourseProduct,
}
